import { branch } from '../constants'

module.exports = (transaction) ->
  typeColorsClass = await Weaver.Node.get('TypeColors', { branch })
  typeColorsInstance = await Weaver.Node.get('typeColors', { branch })
  graphColorsClass = await Weaver.Node.get('GraphColors', { branch })
  graphColorsInstance = await Weaver.Node.get('graphColors', { branch })
  toDestroy = [typeColorsClass, typeColorsInstance, graphColorsClass, graphColorsInstance]
  Weaver.Node.batchDestroy(toDestroy, { transaction, branch })